// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"city-ancient-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M16.0006 4.63921V10H15.9997L20.001 13H20.002V21H4.00195V13H4.00098L7.99966 10H8.00063V4.63901L11.9996 2L16.0006 4.63921Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 18V21M12.0023 5.99805H12.0063V6.00195H12.0023V5.99805Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8.00065 5.15V10M8.00065 10H16.0007M8.00065 10L4.00195 13M16.0007 5.15V10M16.0007 10L20.002 13M20.002 13H4.00195M20.002 13V21H4.00195V13M20.002 13H21.002M4.00195 13H3.00195M7.33398 5.07895L11.9996 2L16.6673 5.07895","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-city-ancient-2')
export default class CityAncient2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-ancient-2',
    }
  }
}
